import { GET, PUT } from '../request'

export const getProfesor = () => GET('/api/profes/personal/profesor')
export const updateFotoPerfil = ({ id, foto }) => {
  const formData = new FormData()
  formData.append('id', id)
  formData.append('foto', foto, foto.filename)
  return PUT('/api/profes/personal/profesor/foto', {}, formData, true)
}
